module.exports = __webpack_public_path__ + "static/media/home.99c0a3cd.svg";